<template>
  <v-dialog v-model="show" max-width="630">
    <template #activator="{ on, attrs }">
      <slot :on="on" :attrs="attrs"></slot>
    </template>
    <v-card>
      <v-card-title>
        Přidat doplňkovú službu
      </v-card-title>
      <v-form @submit.prevent="addAdditionalService()" class="">
        <v-col>
          <v-text-field hide-details="auto" v-model="data.name" label="Název služby" outlined filled dense />
        </v-col>
        <v-col>
          <v-select
              hide-details="auto"
              v-model="data.serviceTypeId"
              :items="translatedServiceTypes"
              item-text="translatedName"
              item-value="_id"
              label="Typ služby"
              outlined filled dense />
        </v-col>
        <v-col>
          <v-text-field
              hide-details="auto"
              v-model.number="data.duration"
              type="number"
              min="0"
              step="1"
              label="Trvání (minuty)"
              outlined filled dense />
        </v-col>
        <v-col>
          <v-text-field
              hide-details="auto"
              v-model.number="data.fixedPrice"
              type="number"
              min="0"
              step="1"
              label="Fixní cena"
              outlined filled dense />
        </v-col>
        <v-col>
          <v-text-field
              hide-details="auto"
              v-model.number="data.providerPercentualShare"
              type="number"
              min="0"
              max="100"
              step="1"
              label="Podíl poskytovatele (%)"
              outlined filled dense />
        </v-col>
        <v-card-actions>
          <v-btn outlined color="primary" @click="close()">Zrušit</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit">PŘIDAT</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AddAdditionalServiceDialog",
  props: {

  },
  data() {
    return {
      data: {},
      serviceTypes: [],
      show: false,
    }
  },
  mounted() {
    this.getServiceTypes()
  },
  methods: {
    addAdditionalService() {
      this.axios.post('/v1/additional-services',this.data).then((data)=>{
        this.$emit('update',data.data)
        this.close()
      })
          .catch((el) => {
            if (el.response && el.response.data && el.response.data.errors) {
              el.response.data.errors.forEach((error) => {
                this.$store.commit('addAlert', {
                  type: 'error',
                  message: error.message
                })
              })
            } else {
              this.$store.commit('addAlert', {
                type: 'error',
                message: "Chyba"
              })
            }
          })
    },
    close() {
      this.show = false
    },
    getServiceTypes() {
      this.axios.get('v1/service-types', { params: { limit: 50 } })
        .then(({data}) => {
          this.serviceTypes = data.data || []
        })
    },
    translateServiceType(serviceName) {
      const translations = {
        'cleaning': 'Úklid',
        'general_cleaning': 'Generální úklid',
        'carpet_beating': 'Tepování',
      }
      return translations[serviceName] || serviceName
    }
  },
  computed: {
    translatedServiceTypes() {
      return this.serviceTypes.map(st => ({
        ...st,
        translatedName: this.translateServiceType(st.serviceName)
      }))
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>
